<template>
  <div
    class="input-container"
  >
    <input
      v-show="edit"
      :id="'input'+item.id"
      :ref="'input'+item.id"
      v-model="getValue"
      type="number"
      min="0"
      tabindex="-1"
      class="form__input"
      @keyup.enter="submit"
      @focus="onFocus"
      @blur="onBlur(item.id)"
    >
    <div
      v-show="!edit"
      class="value-container"
      @click="editThisContent(item.id)"
    >
      <p
        class="form__value"
        :class="animateClickableZone"
      >
        {{ getValue }}
      </p>
      <svg
        viewBox="0 0 24 24"
        class="form__svg"
        :class="animateClickableZone"
        @click="editThisContent(item.id)"
      >
        <path
          d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
          @click="editThisContent(item.id)"
        />
      </svg>
    </div>
    <div
      v-show="command"
      class="helper"
      @click="item.function"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      require: true,
      default: () => ({
        name: 'default',
        function: () => { alert('default function') }
      })
    }
  },
  data: () => ({
    value: 0,
    previousValue: 0,
    edit: false,
    command: false,
    animateClickableZone: ''
  }),
  computed: {
    ...mapGetters([
      'getControls',
      'getClickableArea'
    ]),
    getValue: {
      get() {
        return this.value
      },
      set(value) {
        // handle by value watcher
      }
    }
  },
  watch: {
    getControls: {
      immediate: true,
      handler: 'isEditable',
      deep: true
    },
    value(value, oldvalue) {
      if (value >= 0) {
        if (this.item.sendCopyTo) {
          const id = this.item.sendCopyTo
          this.$store.commit('SET_INPUT_VALUE', { id, value })
        }
      } else {
        this.value = oldvalue
      }
    },
    getClickableArea: {
      handler: 'showClickableArea'
    }
  },
  methods: {
    isEditable() {
      const control = this.getControls[this.item.id]
      this.edit = (control.enableEdit) ? true : ''
      this.value = control.value
    },
    editThisContent(id) {
      this.$store.commit('SET_ENABLE_EDIT', { control: id, value: true })
    },
    onFocus() {
      this.command = true
    },
    onBlur(id) {
      this.$store.commit('SET_ENABLE_EDIT', { control: this.item.id, value: false })
      setTimeout(() => {
        this.command = false
      }, 200)
    },
    submit(e) {
      const value = e.target.value
      this.$store.commit('SET_INPUT_VALUE', { id: this.item.id, value })
      this.$store.commit('SET_ENABLE_EDIT', { control: this.item.id, value: false })
      this.onBlur()
    },
    showClickableArea(value) {
      this.animateClickableZone = (value) ? 'fade-in' : ''
    }
  }
}
</script>
